import React from 'react';
import { Navigate } from 'react-router-dom';
import { subject } from '@casl/ability';
import { AbilityContext } from '../context/Ability';
import { useAbility } from '@casl/react';

const withAbilityCheck = (WrappedComponent, action, module, condition = false) => {
  return (props) => {
    const ability = useAbility(AbilityContext);
    if (condition) {
      if (ability.can(action, subject(module, condition))) {
        return <WrappedComponent {...props} />;
      }
    } else {
      if (ability.can(action, module)) {
        return <WrappedComponent {...props} />;
      }
    }
    return <Navigate to="/blocked" />;
  };
};

export default withAbilityCheck;
